<div class="home-page">
  <div class="home-content">
    <h1 class="home-title">{{ 'home_page.title' | translate }}</h1>
    <p class="home-subtitle">{{ 'home_page.subtitle' | translate }}</p>
  </div>
</div>
